import env from 'enviro';
export const EDITABLE_UTM_SURVEY_ID = env.isQa() ? 485 : 1266;